import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModuleV4 } from '../../../../../../shared/sharedv4.module';
import { AsFormControlPipe } from '../../../../../../transforms/form-control-pipe';
import { FormButtonGroupSimpleComponent } from '../../../../../shared/form-button-group-simple/form-button-group-simple.component';
import { FormFieldCurrencyComponent } from '../../../../../shared/form-field-currency/form-field-currency.component';
import { FormFieldNumericComponent } from '../../../../../shared/form-field-numeric/form-field-numeric.component';
import { FormFieldSelectComponent } from '../../../../../shared/form-field-select/form-field-select.component';
import { FormFieldComponent } from '../../../../../shared/form-field/form-field.component';
import { AddressComponent } from '../../../address/address.component';
import { PersonalAppService } from '../../../../../../services/v4/personal-app.service';
import { EntityContactDetailForm, EntityContactPersonForm, EntityForm } from '../../../../../../types/v4/personal-application-types';
import { BaseStepComponent } from '../../../base-step/base-step.component';

@Component({
  selector: 'app-contact-person',
  standalone: true,
    imports: [
      CommonModule,
      SharedModuleV4,
      FormsModule,
      MatInputModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatStepperModule,
      MatButtonToggleModule,
      MatSnackBarModule,
      FormFieldComponent,
      FormFieldNumericComponent,
      FormFieldCurrencyComponent,
      FormButtonGroupSimpleComponent,
      MatSlideToggle,
      AsFormControlPipe,
      FormFieldSelectComponent,
      MatButtonModule,
      MatIcon,
      MatTooltipModule,
      AddressComponent
    ],
  templateUrl: './contact-person.component.html',
  styleUrl: './contact-person.component.scss'
})
export class ContactPersonComponent extends BaseStepComponent{
  @Input() parentStepper!: MatStepper;
  @Input() fg!: FormGroup<EntityContactPersonForm>;
  @Input() parentFg!: FormGroup<EntityForm>;

  entityTypeCaption: string = '';

  constructor(private fb: FormBuilder,
    PersonalAppService: PersonalAppService
  ) {
    super(PersonalAppService);

    this.personalAppService.entityType$.subscribe(value => {
      this.entityTypeCaption = value;
    });
  }

  
  override ngOnInit(): void {
    super.ngOnInit();

  }

}








